import {
  Box,
  Typography,
  useTheme,
  styled,
  Badge,
  IconButton,
  Button,
} from '@mui/material';
import {useMemo, useState} from 'react';
import {statusOptions as status, statusOptions} from '@jobseeker/feature-job/components/constants';
import {BottomSheet, ButtonV2, Tooltip} from '@jobseeker/lotus/elements';
import {
  ChevronDown,
  CrossOutlined,
  Filter,
} from '@jobseeker/lotus/assets/icons';
import SelectList from './selectList';
import InfoBanner from '@jobseeker/lotus/components/InfoBanner';
import {infoIcon} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {findAppliedJobs} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import {useDispatch} from 'react-redux';
import {useRouter} from 'next/router';

const Imagee = styled(Image)(() => ({}));

const FilterModal = ({
  isFilter,
  showSortBy,
  formValue = {},
  onChange,
  ...props
}: any) => {
  const isFilterBar = isFilter;
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(true); // Toggle tooltip on tap or click

    setTimeout(() => {
      setOpen(false);
    }, 1500);
  };

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const handleClose = () => {
    setOpen(false); // Close tooltip
  };

  const setFormValue = (value: any) => {
    if (onChange) {
      onChange(value);
    }
  };
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  const router = useRouter();

  const submitFilter = async () => {
    const filterString = formValue.join('_'); // Format as 1_2_3_4
    await router.push(
      {
        pathname: router.pathname,
        query: {filters: filterString},
      },
      undefined,
      {shallow: true}
    );

    router.reload();
  };

  const clearFilter = async () => {
    setFormValue({status: []});
  };
  return (
    <BottomSheet
      {...props}
      title="Filter By"
      maxHeight={570}
      header={
        <Box p={2}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              cursor: 'default',
              alignItems: 'center',
              paddingBottom: '1px',
            }}
          >
            {isAppIimjobs ? (
              <Typography
                sx={{
                  variant: 'body2',
                  fontSize: 16,
                  fontWeight: '500',
                  color: '#333',
                  mt: 1,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Filter by Application Status&nbsp;
                <Tooltip
                  arrow
                  disablePortal={false}
                  title={
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 500,
                          borderRadius: 0,
                        }}
                      >
                        Want to know what happened to your applications? Get
                        real time updates as soon as a recruiter performs an
                        action on your application.
                      </Typography>
                    </Box>
                  }
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'preventOverflow',
                        options: {
                          boundary: 'viewport', // Keep within the viewport
                        },
                      },
                    ],
                  }}
                  sx={{zIndex: 9999}}
                  open={open} // Control tooltip visibility
                  onClose={handleClose} // Close the tooltip when necessary
                  disableHoverListener // Disable hover behavior since we are using tap/click
                  disableTouchListener={false} // Enable touch interaction
                  enterTouchDelay={0} // Open immediately on tap
                  leaveTouchDelay={1500} // Close after 1.5 seconds
                >
                  <Image
                    src={infoIcon}
                    height={14}
                    width={14}
                    alt="info"
                    onClick={handleToggle}
                  />
                </Tooltip>
              </Typography>
            ) : (
              <>
                <Typography
                  sx={{
                    variant: 'body2',
                    fontSize: 16,
                    fontWeight: '500',
                    color: '#333',
                    mt: 1,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  Filter by:
                </Typography>
              </>
            )}
          </Box>
          <Box
            sx={{
              position: 'absolute',
              right: 8,
              zIndex: 1,
              top: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'flex-start',
              mt: 2,
            }}
          >
            <Image
              width={18}
              height={18}
              src={CrossOutlined}
              onClick={() => {
                props.onDismiss();
              }}
              alt={'white cross'}
              style={{marginTop: '10px', cursor: 'pointer'}}
            />
          </Box>
        </Box>
      }
      footer={
        isAppIimjobs ? (
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              background: '#fff',
              p: 2,
              borderTop: '1px solid',
              borderColor: 'border.main',
            }}
          >
            <ButtonV2
              variant="outlined"
              size="small"
              onClick={clearFilter}
              color="primary"
              sx={{
                width: '50%',
                mx: 2,
                fontSize: 14,
                borderColor: 'primary',
              }}
            >
              Clear All
            </ButtonV2>
            <ButtonV2
              size="small"
              variant="contained"
              onClick={submitFilter}
              sx={{
                width: '50%',
                mx: 2,
                background: '#333',

                fontSize: 14,
                color: '#FFFFFF',
              }}
            >
              Apply
            </ButtonV2>
          </Box>
        ) : (
          <>
            <Button
              onClick={submitFilter}
              sx={{
                width: 'calc(100% - 20px)',
                border: '1px solid #e9630c',
                borderRadius: '16px',
                marginLeft: 1.25,
                mb: 3.25,
                padding: '5px 20px',
                display: 'flex',
                alignItems: 'center',
                transition: 'background-color 0.3s ease-in-out',
                '&:hover': {
                  backgroundColor: '#e9630c',
                  color: '#fff !important',
                  '& img': {
                    filter: 'brightness(0) invert(1)', // Turns image white
                  },
                  '& .text': {
                    color: '#fff', // Changes Typography color
                  },
                },
              }}
            >
              <Typography
                className="text" // Assigning class for better targeting
                sx={{
                  fontFamily: 'Nunito Sans',
                  fontSize: 14,
                  color: '#e9630c',
                  fontWeight: 500,
                  transition: 'color 0.3s ease-in-out',
                }}
              >
                Apply
              </Typography>
            </Button>
          </>
        )
      }
    >
      <Box
        sx={{
          bgcolor: 'background.paper',
          display: 'flex',
          height: '100%',
        }}
      >
        <SelectList
          onChange={(e: any, value: any) =>
            setFormValue({...formValue, status: value})
          }
          multiSelect
          options={status}
          selected={formValue}
        />
      </Box>
    </BottomSheet>
  );
};

const FilterDialog = (props: any) => {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(props.open ?? false);

  const handleClose = () => {
    setDialogOpen(false);
    if (props.handleClose) {
      props.handleClose();
    }
  };
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const handleOpen = () => {
    setDialogOpen(true);
    if (props.handleOpen) {
      props.handleOpen();
    }
  };
  const handleSelectChange = (event: {status: number[]}) => {
    const selected = event.status;

    if (selected.includes(1) && !props.selectedValues.includes(1)) {
      props.setSelectedValues(
        status.map(option => option.value).filter(value => value !== -1)
      );
    } else {
      if (!selected.includes(1) && props.selectedValues.includes(1)) {
        props.setSelectedValues([]);
      } else {
        let fs = selected;
        if (selected.includes(1) && selected.length < 8) {
          fs = selected.filter(f => f != 1);
        }
        props.setSelectedValues(fs);
      }
    }
  };
  const showBadge = useMemo(() => {
    let value = false;
    for (const key in props.selectedValues) {
      if (props.selectedValues?.length) {
        value = true;
        break;
      }
    }
    return value;
  }, [props.selectedValues]);
  return (
    <>
      <FilterModal
        onChange={handleSelectChange}
        open={dialogOpen}
        formValue={props.selectedValues}
        onDismiss={handleClose}
        {...props}
      />
      {isAppIimjobs ? (
        <Badge
          overlap="circular"
          color="error"
          badgeContent=" "
          invisible={!showBadge}
          sx={{
            margin: theme.spacing(0.875),
            '& .MuiBadge-badge': {
              color: theme.palette.error.dark,
              width: theme.spacing(1),
              height: theme.spacing(1),
              padding: 0,
              minWidth: theme.spacing(1),
              top: '10%',
              right: '24%',
            },
            ml: 0,
            mt: 1.5,
          }}
        >
          <Box
            onClick={handleOpen}
            sx={{
              p: '11px',
              background: '#fff',
              lineHeight: 0,
              filter: 'drop-shadow(0px 6.5px 6px rgba(41, 41, 41, 0.02))',
              borderRadius: '100%',
              border: `1px solid ${theme.palette.gray.dark}`,
              cursor: 'pointer',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Imagee
              src={Filter}
              alt={'Filter'}
              sx={{
                width: {xs: 16},
                height: {xs: 16},
              }}
            />
          </Box>
        </Badge>
      ) : (
        <>
          {props.selectedValues.length === 0 ||
          props.selectedValues.length === 7 ? (
            <Box
              display={'flex'}
              sx={{
                mt: '22px',
                mr: '16px',
                cursor: 'pointer',
                color: 'rgba(0,0,0,.5)',
              }}
              onClick={handleOpen}
            >
              <Typography sx={{fontSize: 14}} onClick={handleOpen}>
                Any Application
              </Typography>
              <Image
                src={ChevronDown}
                alt="down"
                width={12}
                height={12}
                style={{marginLeft: 8, marginTop: 4}}
              />
            </Box>
          ) : (
            <Box
              display={'flex'}
              sx={{
                mt: '22px',
                mr: '16px',
                cursor: 'pointer',
                width: '100%',
                justifyContent: 'flex-end',
                color: 'rgba(0,0,0,.5)',
              }}
              onClick={handleOpen}
            >
              <Typography
                sx={{fontSize: 14, cursor: 'pointer'}}
                onClick={handleOpen}
              >
                {props.selectedValues
                  .map((value: number) => {
                    const match = statusOptions.find(
                      option => option.value === value
                    );
                    return match ? match.label : null;
                  })
                  .filter(Boolean) // Remove null values if any
                  .join(', ')
                  .slice(0, 15)}
                {props.selectedValues.length > 1 ? '...' : ''}
              </Typography>
              {props.selectedValues.length == 1 ? (
                <Image
                  src={ChevronDown}
                  alt="down"
                  width={12}
                  height={12}
                  style={{marginLeft: 8, marginTop: 4}}
                />
              ) : (
                <></>
              )}
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default FilterDialog;
